import styled from '@emotion/styled';
import { theme } from '~/theme';
import { Button } from '~/shared/components/Button/Button';
import { breakpoints } from '~/theme/breakpoints';

export const StyledBasketEmpty = styled.div(({ theme }) => ({
    margin: `0 auto`,
    maxWidth: theme.sizes.pageMaxWidth,
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.white,
    justifyContent: 'space-between',
    textAlign: 'center',
    alignItems: 'center',
    zIndex: 0,
    padding: `${theme.space[6]} ${theme.space[3]} ${theme.space[4]} ${theme.space[3]}`,
    [breakpoints.md]: {
        padding: `${theme.space[6]} ${theme.space[5]} ${theme.space[4]} ${theme.space[5]}`,
    },
}));

export const StyledContinueShopping = styled(Button)(() => ({
    marginTop: `${theme.space[6]}`,
    [breakpoints.md]: {
        width: '350px',
    },
}));
